// @vue/component
export default {
  name: 'PageLayout',

  props: {
    padding: {
      type: String,
      default: '40px',
    },
  },
};
